import React from "react";
import styled from "styled-components";
import Row from "./Row";
import request from "../request";
import { useState, useEffect } from "react";
import axios from "../axios";

const MovieList = () => {
  const baseUrl = "https://image.tmdb.org/t/p/original/";
  const fetchURL = request.actionMovies;


  const [movies, setMovies] = useState([]);
  useEffect(() => {
    const fetchData = async () => {
      const request = await axios.get(fetchURL);
      setMovies(request.data.results);
      return request;
    };

    fetchData();
  }, [fetchURL]);

  return (
    
    <Container>
        <h1>Top Movies</h1>
      <Content>
        {movies.map((m) => {
          return (
            <Wrap>
              <img src={`${baseUrl}${m.poster_path}`} />
            </Wrap>
          );
        })}

        <Wrap>
          <img src="https://wallpapercave.com/wp/AFtCNLt.jpg" />
        </Wrap>
      </Content>
    </Container>
  );
};

export default MovieList;

const Container = styled.div`
padding:20px ;
`;
const Content = styled.div`
  display: grid;
  grid-gap: 25px;
  grid-template-columns: repeat(7, minmax(0, 1fr));
`;
const Wrap = styled.div`
  cursor: pointer;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: rgb(0 0 0 / 69%) 0px 26px 30px -10px,
    rgb(0 0 0 / 73%) 0px 16px 10px -10px;
  transition: all 250ms cubic-bezier(0.25, 0.46, 0.45, 0.94) 0s;
  border: 3px solid rgba(249, 249, 249, 0.1);
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  &:hover {
    transition: scale(1.05);
    box-shadow: rgb(0 0 0 / 69%) 0px 26px 30px -10px,
      rgb(0 0 0 / 73%) 0px 16px 10px -10px;
    border-color: rgba(249, 249, 249, 0.8);
  }
`;
